export const serviceCardData = [
  {
    imgSrc: "assets/img/icon/website.avif",
    title: "Website Design And Development",
    description:
      "A web design application development company that helps businesses build strong customer profiles and reaches potential...",
    link: "/website-design-development",
    children: [
      {
        name: "Website Design And Development",
        link: "/website-design-development",
      },
      {
        name: "PHP Web Development Agency",
        link: "/php-web-development-agency",
      },
      {
        name: "Node.js Development Service",
        link: "/node-js-development-service",
      },
      {
        name: "Angular Development Service",
        link: "/angular-development-service",
      },
      {
        name: "Full stack Development",
        link: "/full-stack-development-service",
      },
      {
        name: "Laravel Development service company",
        link: "/laravel-development-service",
      },
    ],
  },
  {
    imgSrc: "assets/img/icon/mobile app.jpg",
    title: "Mobile Apps",
    description:
      "With custom mobile app development for iOS and Android. We aim to provide a smooth user experience with new advanced features...",
    link: "/mobile-app-development",
  },
  {
    imgSrc: "assets/img/icon/service_3d_3.png",
    title: "Digital Marketing",
    description:
      "Intrinsicly redefine competitive e-business before adaptive potentialiti. Professionally build progressive users with...",
    link: "/digital-marketing-services",
    children: [
      {
        name: "Digital Marketing Service",
        link: "/digital-marketing-services",
      },
      {
        name: "Digital Marketing Strategy Development",
        link: "/digital-marketing-strategy-development",
      },
      {
        name: "Franchise Digital Marketing",
        link: "/franchise-digital-marketing-service",
      },
      {
        name: "Social Media Marketing Service ",
        link: "/social-media-marketing-service",
      },
      {
        name: "Pay per Click Marketing Service",
        link: "/pay-per-click-marketing-service",
      },
    ],
  },
  // {
  //   imgSrc: "assets/img/icon/e-commerce.avif",
  //   title: "E Commerce services",
  //   description:
  //     "Maintaining a stable sales volume is the primary goal of an online seller. However, it is difficult to achieve this unless...",
  //   link: "/e-commerce-services",
  // },
  {
    imgSrc: "assets/img/icon/seo.png",
    title: "Search Engine Optimization",
    description:
      "With custom SEO strategies for higher visibility and traffic, we aim to boost your search rankings through advanced techniques and performance-driven solutions...",
    link: "/search-engine-optimzation",
    children: [
      {
        name: "Search Engine Optimization",
        link: "/search-engine-optimzation",
      },
      {
        name: "Ecommerce SEO",
        link: "/ecommerce-seo-service",
      },
      {
        name: "SEO Consultant",
        link: "/seo-consultant-service",
      },
      {
        name: "Technical SEO",
        link: "/technical-seo-service",
      },
      {
        name: "Local SEO",
        link: "/local-seo-service",
      },
      {
        name: "SEO Audit",
        link: "/seo-audit-service",
      },
      {
        name: "SEO Content Writing",
        link: "/seo-content-writing-service",
      },
    ],
  },
  {
    imgSrc: "assets/img/icon/accountandbook.jpg",
    title: "Accounting and Book Keeping",
    description:
      "Finance accounting and bookkeeping services, is extremely important aspect for any business and certainly requires time...",
    link: "/accounting-bookkeeping-services",
  },
  {
    imgSrc: "assets/img/icon/content.avif",
    title: "Content Writing",
    description:
      "Content writing is all about drafting thoughts and business ideas on paper. It is the process of planning, researching, ...",
    link: "/content-writing-service",
  },
  {
    imgSrc: "assets/img/icon/data-manage.avif",
    title: "Data management",
    description:
      "To be an efficient fuel source for businesses, data must be managed efficiently. Data management services are...",
    link: "/data-management-services",
  },
  // {
  //   imgSrc: "assets/img/icon/virtual.jpg",
  //   title: "Virtual Learning",
  //   description:
  //     "In the digital age, doing mundane tasks within the same organization is now rare. It is difficult to manage all aspects...",
  //   link: "/virtual-learning-services",
  // },
  // {
  //   imgSrc: "assets/img/icon/csp.avif",
  //   title: "Voice Support",
  //   description: "When you're looking to make your business stand out, voice assistance services add the missing feature...",
  //   link: "/call-preference-service",
  // },
  // {
  //   imgSrc: "assets/img/icon/omni.jpg",
  //   title: "Omni Support",
  //   description: "In German it is 'der Kunde ist König' (customer is king) or in Japanese, it is 'okyakusama wa kamisama desu'...",
  //   link: "/omni-support",
  // },

  // {
  //   imgSrc: "assets/img/icon/graphic-designer.jpg",
  //   title: "Graphic Design",
  //   description: "Our expert offers graphic design services with cover branding, logo creation, UI/UX design, and promotional materials...",
  //   link: "/graphic-design",
  // },
  // {
  //   imgSrc: "assets/img/icon/software.jpg",
  //   title: "Software Development",
  //   description:
  //     "Custom software development solutions for businesses. It includes enterprise-level applications, SaaS development, automation tools...",
  //   link: "/software-development",
  // },
];
